jQuery.noConflict();
jQuery(document).ready(function($) {
  if(($('.my_account_container').length && window.matchMedia('(max-width: 991px)').matches) || ($('#soff_browse').length && window.matchMedia('(max-width: 767px)').matches)){
    $('.soff_responsive_menu').appendTo('body');
  }

  $('.soff_responsive_menu_hamburger').click(function(){
    let menuID = '#' + $(this).data('target');
    $(menuID).toggleClass('open');
  });
  $('.soff_responsive_menu_close').click(function(){
    $(this).closest('.soff_responsive_menu').removeClass('open');
  });

  $(window).resize(function() {
    if(!$('#soff_keywords').is(":focus")){
      if(($('.my_account_container').length && window.matchMedia('(max-width: 991px)').matches) || ($('#soff_browse').length && window.matchMedia('(max-width: 767px)').matches)){
        $('.soff_responsive_menu').appendTo('body');
      }
      else{
        if($('.my_account_container').length){
          $('.soff_responsive_menu').prependTo('.my_account_container');
        }
        else if($('#soff_browse').length){
          $('.soff_responsive_menu').prependTo('#soff_browse');
        }
      }
    }
  });
});
